import * as React from 'react';

export interface CountdownTimerProps {
  interval: number;
  onEnd: () => void;
}

export const CountdownTimer: React.FC<CountdownTimerProps> = ({
  interval,
  onEnd,
}) => {
  const [counter, setCounter] = React.useState(interval);

  React.useEffect(() => {
    let timer: number | undefined;
    if (counter > 0) {
      timer = window.setTimeout(() => setCounter(counter - 1), 1000);
    }
    if (counter === 0) {
      onEnd();
    }
    return () => window.clearTimeout(timer);
  }, [counter, onEnd]);

  return <span>{counter}</span>;
};

export default CountdownTimer;